import { useLocation } from 'react-router-dom';
import { categories, articles } from '@/mocks/data';

export default function SEOMeta() {
  const location = useLocation();
  const path = location.pathname;

  let title = '亚洲欧美风格融合指南 - 跨文化时尚与生活方式全解析';
  let description = '探索亚洲欧美跨文化融合的无限可能，从时尚穿搭、美妆潮流到生活方式，深度解析亚洲欧美两大风格体系的碰撞与共鸣。';
  let canonical = 'https://shenshang003.cn';

  if (path.startsWith('/category/')) {
    const slug = path.split('/category/')[1];
    const cat = categories.find((c) => c.slug === slug);
    if (cat) {
      title = `${cat.name} - 亚欧风格志`;
      description = cat.description;
      canonical = `https://shenshang003.cn/category/${slug}`;
    }
  } else if (path.startsWith('/article/')) {
    const slug = path.split('/article/')[1];
    const article = articles.find((a) => a.slug === slug);
    if (article) {
      title = `${article.title} - 亚欧风格志`;
      description = article.excerpt;
      canonical = `https://shenshang003.cn/article/${slug}`;
    }
  } else if (path === '/about') {
    title = '关于我们 - 亚欧风格志';
    description = '了解亚欧风格志的品牌故事、团队背景和联系方式。我们专注于亚洲欧美跨文化时尚与生活方式的深度内容创作。';
    canonical = 'https://shenshang003.cn/about';
  }

  document.title = title;

  const setMeta = (name: string, content: string, attr: string = 'name') => {
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  setMeta('description', description);
  setMeta('og:title', title, 'property');
  setMeta('og:description', description, 'property');
  setMeta('og:url', canonical, 'property');
  setMeta('twitter:title', title);
  setMeta('twitter:description', description);

  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', canonical);

  return null;
}